import { fanduel as fd } from "@fanduel/formation-tokens";
import cx from "classnames";
import Lock from "@/components/svg/Lock";
import styles from "./oddsUnavailable.module.scss";

export const EmptyMessage = ({ className }: { className?: string }) => (
  <div className={cx(styles.emptyMessageCard, className)}>
    <Lock fill={fd.colors.coreNavyD3} />
    <div className={styles.title}>Odds not available yet.</div>
    <div className={styles.microcopy}>Check back closer to game time!</div>
  </div>
);

const Skeleton = () => (
  <div className={styles.skeletonCard}>
    <div className={styles.header}>
      <div className={styles.labelContainer}>
        <div className={styles.labels}>
          <span>OVER</span>
          <span>UNDER</span>
        </div>
      </div>
    </div>
    <div className={styles.betContainer}>
      <div className={styles.betLinks}>
        <div className={styles.btnPlaceholder} />
        <div className={styles.btnPlaceholder} />
      </div>
      <div className={styles.betLinks}>
        <div className={styles.btnPlaceholder} />
        <div className={styles.btnPlaceholder} />
      </div>
      <div className={styles.betLinks}>
        <div className={styles.btnPlaceholder} />
        <div className={styles.btnPlaceholder} />
      </div>
    </div>
  </div>
);

const OddsUnavailable = () => (
  <div className={styles.container}>
    <div className={styles.skeletons}>
      <Skeleton />
      <Skeleton />
    </div>
    <EmptyMessage />
  </div>
);

export default OddsUnavailable;
